import React from 'react'

interface ReportingContextProps {
  reportingData: any
  setReportingData: (data: any) => void
  startDate: Date | null
  setStartDate: (startDate: Date | null) => void
  endDate: Date | null
  setEndDate: (endDate: Date | null) => void
  datePeriod: number | null
  setDatePeriod: (datePeriod: number | null) => void
  filter: any
  setFilter: (filter: any) => void
  appId: number | string
  setAppId: (appId: number | string) => void
  totalRatings: number
  setTotalRatings: (total: number) => void
  openSubApps: boolean
  setOpenSubApps: (openSubApps: boolean) => void
  chosenDepartment: string
  setChosenDepartment: (department: string) => void
  chosenApplication: string
  setChosenApplication: (chosenApplication: string) => void
  departmentButton: string
  setDepartmentButton: (departmentButton: string) => void
  applicationButton: string
  setApplicationButton: (applicationButton: string) => void
  cellContentAppWithSubApps: any
  setCellContentAppWithSubApps: (cellContentAppWithSubApps: any) => void
  openFilterMenu: boolean
  setOpenFilterMenu: (openFilterMenu: boolean) => void
  showSingleRatings: boolean
  setShowSingleRatings: (showSingleRatings: boolean) => void
  showDepartmentList: boolean
  setShowDepartmentList: (showDepartmentList: boolean) => void
  showTeamDepartmentList: boolean
  setShowTeamDepartmentList: (showTeamDepartmentList: boolean) => void
  applicationList: any
  setApplicationList: (applicationList: any) => void
  allApplications: any
  setAllApplications: (allApplications: any) => void
  openDepartmentMenu: boolean
  setOpenDepartmentMenu: (openDepartmentMenu: boolean) => void
  openApplicationMenu: boolean
  setOpenApplicationMenu: (openApplicationMenu: boolean) => void
  calendarIsOpen: boolean
  setCalendarIsOpen: (calenderIsOpen: boolean) => void
  contentHeader: string
  setContentHeader: (contentHeader: string) => void
  setResetParams: (resetParams: boolean) => void
  singleRatings: any
  setSingleRatings: (singleRatings: any) => void
}

export const ReportingContext = React.createContext<ReportingContextProps>({
  reportingData: {},
  setReportingData: () => {},
  startDate: null,
  setStartDate: () => {},
  endDate: null,
  setEndDate: () => {},
  datePeriod: 0,
  setDatePeriod: () => {},
  filter: {},
  setFilter: () => {},
  appId: 0,
  setAppId: () => {},
  openSubApps: false,
  totalRatings: 0,
  setTotalRatings: () => {},
  setOpenSubApps: () => {},
  chosenDepartment: '',
  setChosenDepartment: () => {},
  chosenApplication: '',
  setChosenApplication: () => {},
  departmentButton: '',
  setDepartmentButton: () => {},
  applicationButton: '',
  setApplicationButton: () => {},
  cellContentAppWithSubApps: [],
  setCellContentAppWithSubApps: () => {},
  openFilterMenu: false,
  setOpenFilterMenu: () => {},
  showSingleRatings: false,
  setShowSingleRatings: () => {},
  showDepartmentList: false,
  setShowDepartmentList: () => {},
  showTeamDepartmentList: false,
  setShowTeamDepartmentList: () => {},
  applicationList: [],
  setApplicationList: () => {},
  allApplications: [],
  setAllApplications: () => {},
  openDepartmentMenu: false,
  setOpenDepartmentMenu: () => {},
  openApplicationMenu: false,
  setOpenApplicationMenu: () => {},
  calendarIsOpen: false,
  setCalendarIsOpen: () => {},
  contentHeader: '',
  setContentHeader: () => {},
  setResetParams: () => {},
  singleRatings: {},
  setSingleRatings: () => {}
})
